var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"study-Location"},[_c('div',{staticClass:"DoT-one1"}),_vm._v(" "),_c('div',{staticClass:"DoT-two2"}),_vm._v(" "),_c('div',{staticClass:"Training"},[_c('p',[_vm._v(_vm._s(_vm.$t('i.search.selfSocialRegulation')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d6fb9d4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/search/components/rules.vue
// module id = null
// module chunks = 